import profileIcon from "@img/ptofile.svg";
import { useAuth } from "@/utils/auth-context";
import { useState } from "react";
import AmazonIcon from "./UI/AmazonIcon";
import * as React from "react";
import Sidenav from "./UI/SideNav";
import MenuIcon from "./UI/MenuIcon";
import Timer24h from "@components/UI/Timer24h.jsx";

const Header = React.memo(() => {
  const { isAuthenticated, email, user, logout, isVerified } = useAuth();
  const adminId = "DyNgoxrjL3RtmQZyeeZ60maTo0F2";
  const [mobileNavOpen, setMobileNav] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const toggleDrawerMobile = (state) => () => {
    setMobileNav(state);
  };

  const renderMenu = React.useMemo(() => {
    return (
      <div className={`header-menu`}>
        <p>
          Вы вошли как <br /> <span className="bold">{email}</span>
        </p>
        <hr className={`header-menu__line `} />
        <a href="/account/general" className={`header-menu__item`}>
          Аккаунт
        </a>
        <button
          onClick={() => {
            logout();
            setIsMenuOpen(false);
          }}
          className={`header-menu__button`}
        >
          Выйти
        </button>
      </div>
    );
  }, [email, logout]);

  return (
    <div className={`header`}>
      <div className="wrapper">
        <AmazonIcon />
        <div className="header-buttons">
          {isAuthenticated && (
            <>
              <div className="header-navigation">
                <a
                  className="header-navigation__item"
                  href="/course/amazon/lessons"
                >
                  Курсы
                </a>
                <a className="header-navigation__item" href="/account/general">
                  Аккаунт
                </a>
                {user?.uid === adminId && (
                  <a href="/users" className="header-navigation__item">
                    Пользователи
                  </a>
                )}
              </div>

              <button className="header-buttons__item" onClick={toggleMenu}>
                <img
                  className="header-buttons__item__img"
                  src={profileIcon}
                  alt="profile menu"
                />
              </button>
              <button
                className="header-mobile__button"
                onClick={toggleDrawerMobile(true)}
              >
                <MenuIcon color="white" />
              </button>
            </>
          )}
        </div>

        <Sidenav
          setIsOpen={setMobileNav}
          isOpen={mobileNavOpen}
          onClose={toggleDrawerMobile(false)}
          header={"header"}
        >
          <div className="header-mobile">
            <a className="" href="/course/trial/lessons">
              Курсы
            </a>
            <a className="" href="/account/general">
              Аккаунт
            </a>
            {user?.uid === adminId && (
              <a href="/users" className="">
                Пользователи
              </a>
            )}
          </div>
        </Sidenav>

        {isMenuOpen && renderMenu}
      </div>

      {isAuthenticated && user?.metadata?.createdAt && (
        <Timer24h
          createdAt={Number(user.metadata.createdAt)}
          isVerified={isVerified}
        />
      )}
    </div>
  );
});

export default Header;
